import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from 'services/constants';
import { RootState } from 'state/store';

export const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const { token } = (getState() as RootState)?.authState;
    if (token) {
      headers.set('authorization', token);
    }

    return headers;
  },
});
